import { getCurrentTranslation } from '~/data/people';
import { People } from '~/services/Http';

import { QuickLinkViewItem } from '../models';

export const mapGeneralQuickLinksToQuickLinkViewItems = (
  generalQuickLinks: People.QuickLinkDto[],
  hiddenQuickLinkIds: string[],
): QuickLinkViewItem[] =>
  generalQuickLinks.map((link) => {
    const currentTranslation = getCurrentTranslation(link.translations);
    const name = currentTranslation?.name;
    const description = currentTranslation?.description;

    return {
      active: !hiddenQuickLinkIds.includes(link.id),
      id: link.id,
      name,
      description,
      url: `${link.url}`,
      location: link.location,
      ...(link.navigation ? { navigation: link.navigation } : {}),
      ...(link.seq || link.seq === 0 ? { seq: link.seq } : {}),
    };
  });
